// src/apis/PaymentInitiator.js
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { PAYMENT_INITIATE } from "../services/actions";

const usePaymentInitiator = () => {  // ✅ Hook name starts with "use"
  const dispatch = useDispatch();

  const initiatePayment = useCallback((paymentData, callback) => {
    // Validate payload
    if (!paymentData?.loan_number || !paymentData?.amount || !paymentData?.customer_id) {
      callback({ 
        is_success: false, 
        message: "Missing payment information" 
      });
      return;
    }

    // Dispatch Redux action
    dispatch({
      type: `${PAYMENT_INITIATE}_POST`,
      payload: {
        loan_number: paymentData.loan_number,
        amount: parseFloat(paymentData.amount).toFixed(2), 
        customer_id: paymentData.customer_id,
        module_code: paymentData.module_code || "DEFAULT",
        gateway: paymentData.gateway || "PHONEPE"
      },
      callback: (resp) => {
        console.log("📱 Payment init response:", resp);
        callback(resp);  // Return response to caller
      }
    });
  }, [dispatch]);

  return { initiatePayment };  // ✅ Return object with method
};

export default usePaymentInitiator;
